import script from "./HeroSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroSection.vue?vue&type=script&setup=true&lang=js"

import "./HeroSection.vue?vue&type=style&index=0&id=a0896882&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0896882"]])

export default __exports__